module.exports = __webpack_public_path__ + "img/front_tireman.72fdeb61.webp";